export const trackResponse = data =>
  fetch(`/api/v1/experiment/track?${$.param(data)}`, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });

export class Metric {
  constructor(selector) {
    this.selector = selector;
  }
  /**
   * This method is used for sending track and metrics
   **/
  send(metricName) {
    trackResponse({
      name: metricName
    });
  }
  /**
   * sendGlobalOnClick method is used for sending track and metrics from all project's pages by data attribute
   **/
  sendGlobalOnClick() {
    const metricSelector = this.selector;
    const sendMetric = this.send;
    if (metricSelector) {
      metricSelector.on("click", function() {
        const name = $(this).attr("data-send-metric");
        sendMetric(name);
      });
    }
  }
  /**
   * sendOnScroll - method is used when scrolling to a certain element for sending track and metrics
   **/
  sendOnScroll(selectorName, metricName) {
    let statusSendMetric = false;
    if (selectorName.length && metricName) {
      $(document).on("scroll", () => {
        let elementDistance =
          selectorName[0].getBoundingClientRect().top - $(window).height();

        if (elementDistance < 0 && !statusSendMetric) {
          this.send(metricName);
          statusSendMetric = true;
        }
      });
    }
  }
}
